const init = () => {
  const body = document.body;
  const current_path = window.location.pathname;

  if (current_path == '/password/reset' || current_path == '/') {
    body.style.backgroundImage = "url('https://user-images.githubusercontent.com/47460478/196742144-2ec1cd0f-5e50-4691-bc53-9614f04e2467.jpg')";
    body.style.backgroundSize = 'cover';
    body.style.backgroundRepeat = 'no-repeat'
  }
}

init();